import * as MUI from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { INVOICE_NUMBERING_SCHEMES } from "./utils/invoiceNumberingSchemes";

const DEFAULT_SCHEME = INVOICE_NUMBERING_SCHEMES[0].key;

export default function InvoiceSettings({
  scheme,
  onSchemeChange,
  premisesCode,
  onPremisesCodeChange,
  nextInvoiceNumber,
  onNextInvoiceNumberChange,
  onSaveStartingSequence,
  isUpdatingSequence,
  ConfirmationDialog,
}) {
  const { t } = useTranslation();
  const enabled = scheme !== "NONE";

  return (
    <MUI.Stack spacing={2}>
      <MUI.FormControlLabel
        control={
          <MUI.Switch
            checked={enabled}
            onChange={(e) => onSchemeChange(e.target.checked ? DEFAULT_SCHEME : "NONE")}
            inputProps={{ "data-testid": "clinic.options.invoice.enabled-switch" }}
          />
        }
        label={t("EnableInvoiceSequencing")}
      />

      {enabled && (
        <>
          <MUI.FormControl fullWidth>
            <MUI.InputLabel id="invoice-scheme-label">{t("Country")}</MUI.InputLabel>
            <MUI.Select
              labelId="invoice-scheme-label"
              label={t("Country")}
              value={scheme}
              onChange={(e) => onSchemeChange(e.target.value)}
              SelectDisplayProps={{ "data-testid": "clinic.options.invoice.scheme-select" }}
              inputProps={{ "data-testid": "clinic.options.invoice.scheme-select.value" }}
            >
              {INVOICE_NUMBERING_SCHEMES.map(({ key, labelKey }) => (
                <MUI.MenuItem key={key} value={key}>
                  {t(labelKey)}
                </MUI.MenuItem>
              ))}
            </MUI.Select>
          </MUI.FormControl>

          <MUI.TextField
            fullWidth
            type="number"
            label={t("InvoicePremisesCode")}
            value={premisesCode}
            onChange={(e) => onPremisesCodeChange(e.target.value)}
            inputProps={{ min: 1, step: "1", "data-testid": "clinic.options.invoice.premises-code-input" }}
          />

          <MUI.Stack direction="row" spacing={2} alignItems="center">
            <MUI.TextField
              fullWidth
              type="number"
              label={t("NextInvoiceNumber")}
              value={nextInvoiceNumber}
              onChange={(e) => onNextInvoiceNumberChange(e.target.value)}
              inputProps={{ min: 1, step: "1", "data-testid": "clinic.options.invoice.next-number-input" }}
            />
            <MUI.Button
              variant="outlined"
              disabled={isUpdatingSequence || !nextInvoiceNumber}
              onClick={onSaveStartingSequence}
              data-testid="clinic.options.invoice.save-sequence-button"
            >
              {t("Save")}
            </MUI.Button>
          </MUI.Stack>
        </>
      )}
      <ConfirmationDialog />
    </MUI.Stack>
  );
}
